<template>
  <div class="scoreTable">
    <span class="tip">成绩详情</span>
    <a class="btnExport" v-if="!(scoreData.pageList && !scoreData.pageList.length)" :href="url">导出</a>
    <noFound v-if="scoreData.pageList && !scoreData.pageList.length"></noFound>
    <div v-else>
      <table cellspacing='0'>
          <tr>
            <th>作业</th>
            <th>布置对象</th>
            <th>
              提交率<br>
            </th>
            <th>
              优秀率<br>
              （≥90）
            </th>
            <th>
              及格率<br>
              （≥60）
            </th>
            <th>
              不及格率<br>
              （＜60）
            </th>
          </tr>
      </table>
      <table class="chunkT" cellspacing='0' v-for="item in scoreData.pageList">
          <tr v-for="(ritem, rindex) in item.contentList">
              <td class="dateT" :rowspan="item.contentList.length" v-if="rindex==0">{{item.sendDate}}</td>
              <td class="wName">
                {{ritem.resourceName}}
              </td>
              <td>
                {{ritem.receiver}}
              </td>
              <td>
                {{ritem.submitRate}}%
              </td>
              <td>
                {{ritem.excellentRate}}%
              </td>
              <td>
                {{ritem.passRate}}%
              </td>
              <td>
                {{ritem.failRate}}%
              </td>
          </tr>
      </table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
        :page-size="5" layout="total, prev, pager, next" :total="scoreData.totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import noFound from "./../noData/nodata.vue";
export default {
  props: ['scoreData', 'url'],
  data() {
    return {
      currentPage: 1
    };
  },
  components: {
    noFound
  },
  created() {
    this.$nextTick(() => {
    })
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('setPage', val)
    },
    handleCurrentChange(val) {
      this.$emit('setPage', val)
    }
  }
};
</script>



// WEBPACK FOOTER //
// scoreTable.vue?41cf198b